import React, { useEffect } from "react";
import { Link } from "react-router-dom"; 
import Select from "react-select";
import CityDropdown from "../components/CityDropdown"; 
import LatestOffplanHome from "../components/lastestoffplanhome";
import OffplanbycityHome from "../components/offplanbycity_home";
import LatestBlog from "../components/latestblog";
import HotPropertyHome from "../components/hotpropertyhome";
import CityHome from "../components/listofcityhome";
import TrustedPartner from "../components/trustedpartner";
import TestimonialHome from "../components/testimonialhhome";
import BannerSlider from "../components/BannerSlider";
import faq from "../components/faq";
import PropertySearchControlHome from "../components/PropertySearchcontrolhome";
import FAQ from "../components/faq";
import Slider from "../components/slider";
import CTA from "../components/cta";
const propertytypeopt = [
  { value: "All", label: "Property Type" },
  { value: "Apartment", label: "Apartment" },
  { value: "Townhouse", label: "Townhouse" },
  { value: "Villa", label: "Villa" },
  { value: "Penthouse", label: "Penthouse" },
  { value: "Office", label: "Office" },
  { value: "Shop", label: "Shop" },
  { value: "Showroom", label: "Showroom" },
  { value: "Residential Plot", label: "Residential Plot" },
  { value: "Residential Building", label: "Residential Building" },
  { value: "Hotel Apartment", label: "Hotel Apartment" },
  { value: "Residential Floor", label: "Residential Floor" },
  { value: "Warehouse", label: "Warehouse" },
  { value: "Commercial Villa", label: "Commercial Villa" },
  { value: "Commercial Plot", label: "Commercial Plot" },
  { value: "Commercial Building", label: "Commercial Building" },
  { value: "Industrial Land", label: "Industrial Land" },
  { value: "Labour Camp", label: "Labour Camp" },
  { value: "Bulk Unit", label: "Bulk Unit" },
  { value: "Commercial Floor", label: "Commercial Floor" },
  { value: "Factory", label: "Factory" },
  { value: "Mixed Use Land", label: "Mixed Use Land" },
];
function Home()
{
    useEffect(() => {
      let resetTimer;
      const resetHomeScroll = () => {
        window.clearTimeout(resetTimer);
        resetTimer = window.setTimeout(() => {
          window.scrollTo({ top: 0, left: 0, behavior: "auto" });
          document.documentElement.scrollTop = 0;
          document.body.scrollTop = 0;
        }, 80);
      };

      resetHomeScroll();
      window.addEventListener("orientationchange", resetHomeScroll);
      // Mobile browsers fire resize/visualViewport resize while the address bar
      // collapses during normal scrolling, which can trap the home page at top.

      return () => {
        window.clearTimeout(resetTimer);
        window.removeEventListener("orientationchange", resetHomeScroll);
      };
    }, []);

    return(
    <>
   <div className="home-hero-wrap">
   <Slider/>
  <div className="topbanner-bottom">
    <div className="flat-tab flat-tab-form">
       <PropertySearchControlHome/>
    </div>
  </div>
</div>


  {/* End Slider */}
  {/* Location */}
   
  <section className="flat-section flat-recommended alternatebg">
    <div className="container">
      <div
        className="box-title style-1 wow fadeInUp"
        style={{ textAlign: "left" }}
      >
         <h3 className="title mt-4">
         Discover Prime Areas to Live
        </h3>
      </div>
     <CityHome />
    </div>
  </section>
   <section className="flat-section flat-recommended dn-mob1">
    <div className="container">
      <div
        className="box-title wow fadeInUp"
        style={{ visibility: "visible", animationName: "fadeInUp" }}
      > 
        <h3 className="title mt-4">Latest off-plan Launches</h3>
      </div>
     <LatestOffplanHome city="All" home="Yes"/>
    </div>
  </section>
  {/* Latest New */}
  <section className="flat-section agnts alternatebg">
    <div className="container">
      <div
        className="box-title style-1 wow fadeInUp"
        style={{ visibility: "visible" }}
      > 
        <h3 className="title mt-4">Top Developers in Abu Dhabi</h3>
      </div>
     <TrustedPartner city="Abu Dhabi"/>
    </div>
  </section> 
  <section className="flat-section agnts alternatebg">
    <div className="container">
      <div
        className="box-title style-1 wow fadeInUp"
        style={{ visibility: "visible" }}
      > 
        <h3 className="title mt-4">Top Developers in Dubai</h3>
      </div>
     <TrustedPartner city="Dubai"/>
    </div>
  </section>  
   <section className="flat-section flat-recommended">
    <div className="container">
      <div className="box-title style-1 wow fadeInUp">
         <h3 className="title mt-4">Properties for sale</h3>
      </div>
      <HotPropertyHome offertype="Sale" typ="Home" />
    </div>
  </section> 
   <section className="flat-section flat-recommended alternatebg">
    <div className="container">
      <div className="box-title style-1 wow fadeInUp">
         <h3 className="title mt-4">Properties for Rent</h3>
      </div>
      <HotPropertyHome offertype="Rent" typ="Home" />
    </div>
  </section>
   {/* Testimonial */}
  <section className="flat-section flat-testimonial" style={{ paddingTop: 40 }}>
    <div className="container">
      <div className="box-title wow fadeInUp">
        <div
          className="wow fadeInUpSmall"
          data-wow-delay=".2s"
          data-wow-duration="2000ms"
        >
          <div className="text-subtitle text-primary">Our Testimonials</div>
          <h3 className="title mt-4">What our clients say about us</h3>
        </div>
      </div>
       <TestimonialHome />
    </div>
  </section>
  {/* End Testimonial */}
 
  {/* End Location */}
  {/* Benefit */}
  {/* Recommended */}
  {/* End Recommended */} 
  {/* End Benefit */}
   <CTA />
  {/* Latest New */}
  <section className="flat-section">
    <div className="container">
      <div
        className="box-title style-1 wow fadeInUp"
        style={{ visibility: "visible" }}
      >
        <div className="text-subtitle text-primary">Latest New</div>
        <h3 className="title mt-4">Latest Blog Posts & Property Tips</h3>
      </div>
      <div className="row">
       <LatestBlog typ="Latest News" id="0" home="Yes"/>
       </div>
    </div>
  </section> 
 <FAQ/>

</>

    );
}
export default Home;

